import React from 'react';

export default () => (
  <div className="box">
    <div className="box-header-timeline"></div>
    <div className="box-body">
      <h3>Help us build FreeFeed</h3>

      <p>We are looking for volunteers to help us build FreeFeed, an open-source
        social network, replacement of FriendFeed.com.</p>

      <p>We <a href="https://dev.freefeed.net" target="_blank" rel="noopener">need help</a> with both development and testing.</p>

      <p>FreeFeed is open-source: <a href="https://github.com/FreeFeed/" target="_blank" rel="noopener">https://github.com/FreeFeed/</a></p>

      <p>The <a href="https://github.com/FreeFeed/freefeed-server" target="_blank" rel="noopener">backend</a> is
        built with Node.js and PostgreSQL.</p>

      <p>The <a href="https://github.com/FreeFeed/freefeed-react-client" target="_blank" rel="noopener">frontend</a> is built
        with React.</p>

      <p><b><a href="https://dev.freefeed.net" target="_blank" rel="noopener">Join</a></b> our team of volunteers!</p>
    </div>
  </div>
);
